module.exports = __webpack_public_path__ + "static/media/aprobado icono.860ff13a.svg";